import React, {useState, useEffect, useRef, useMemo} from 'react';
import {Button, Col, Row, Table} from 'react-bootstrap';
import "leaflet/dist/leaflet.css";
import * as turf from 'turf'
import {MapContainer, TileLayer, Polygon, LayersControl, LayerGroup, FeatureGroup} from 'react-leaflet'
import L from 'leaflet';
import "./Profile.css"
import {useParams, Link, useNavigate} from 'react-router-dom';
import {formatDate, FlyToMap, extractBBoxByCoordinates} from './Profile';
import {itemsToPolygons} from '../../utils/itemsToPolygons';
import axiosHandler from "../../services/https";
import * as Leaflet from "leaflet";
import {connect} from "react-redux";
import {addItemsToQueue} from "../../action/download";
import MapitalyModal from "../MapitalyModal";
import {ArrowClockwise, ArrowDown, Check, Exclamation, HourglassBottom, HourglassSplit} from "react-bootstrap-icons";

const { BaseLayer } = LayersControl
const ProfileDetails = ({isAuthenticated, user, addItemsToQueue}) => {
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [checkForStatusChange, setCheckForStatusChange] = useState(false);
    const mapRef = useRef(null);

    // modal for communication --------------------
    const defaultModal = {
        modalTitle: "",
        modalText: "",
        confirmText: "",
        cancelText: "",
        show: false,
        handleClose: () => {
            updateModal({show: false});
        },
        handleHide: null,
        handleConfirm: null,
        handleCancel: null
    };
    const [modal, setModal] = useState(defaultModal);
    const updateModal = (updates, reset = false) => {
        const placeholder = reset ? defaultModal : modal;
        setModal({...placeholder, ...updates});
    }
    const popupError = (message) => {
        updateModal({
            modalText: message,
            show: true
        });
    }

    // MULTIDOWNLOAD
    const {orderId} = useParams();
    const [orderDetails, setOrderDetails] = useState(null);

    // Accesso rapido a dettagli di order
    let order = null;
    if (orderDetails) {
        order = {
            code: orderId,
            date: formatDate(orderDetails.created),
            description: orderDetails.description,
            features: orderDetails.process.arguments.frames.features.map((feature, index) => {
               return {...feature, item: orderDetails.process.item_list.features.find(elem => elem.id === feature.properties.id_L0)};
            })
        };
    }

    useEffect(() => {
        if (orderId) {
            let accessToken = localStorage.getItem('access');
            axiosHandler.getInstance().get(`${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_API_JOB}${orderId}`)
                .then((response) => {
                    setOrderDetails(response.data);
                    if (response.data.process && response.data.process.item_list && response.data.process.item_list.features) {
                        drawOriginalPolygon(response.data.process.item_list.features)
                    }
                }).catch((error) => {
                console.error('Error fetching order details:', error);
            });
        }
    }, [orderId, checkForStatusChange]);

    const isDownloadAvailable = (frame_id) => {
        if (orderDetails && orderDetails.frames_status) {
            // const frameStatus = orderDetails.frames_status;
            // const frameKeys = Object.keys(frameStatus);
            // const currentFrameKey = frameKeys[index];
            return downloadStatus(frame_id) === "finished";
        } else {
            return false;
        }
    };

    // const isDownloadAvailable = (index) => {
    //     if (orderDetails && orderDetails.frames_status) {
    //         const frameStatus = orderDetails.frames_status;
    //         const frameKeys = Object.keys(frameStatus);
    //         const currentFrameKey = frameKeys[index];
    //         return frameStatus[currentFrameKey] === "finished";
    //     } else {
    //         return false;
    //     }
    // };


    // const downloadStatusAlt1 = (index) => {
    //     if (orderDetails && orderDetails.frames_status) {
    //         const frameStatus = orderDetails.frames_status;
    //         const frameKeys = Object.keys(frameStatus);
    //         const currentFrameKey = frameKeys[index];
    //         return frameStatus[currentFrameKey]
    //     }
    // }

    const downloadStatus = (frame_id) => {
        if (orderDetails && orderDetails.frames_status) {
            for (const [key, value] of Object.entries(orderDetails.frames_status)) {
                if (key === frame_id) {
                    return value
                }
            }
            // const frameStatus = orderDetails.frames_status;
            // const frameKeys = Object.keys(frameStatus);
            // const currentFrameKey = frameKeys[index];
            // return frameStatus[currentFrameKey]
        }
    }

    const renderColumnNames = (tab, columns) => {
        if (tab === "downloads") {
            return <tr>
                <th align='center'>
                    <input
                        type="checkbox"
                        name="selectedItem"
                        checked={selectAllChecked}
                        onChange={(e) => e.target.checked ? handleSelectAll() : handleDeselectAll()}
                    />
                </th>
                {columns.map((column, index) => (
                    <th key={index}>{column}</th>
                ))}
            </tr>
        } else {
            return <tr>
                {columns.map((column, index) => (
                    <th key={index}>{column}</th>
                ))}
            </tr>
        }
    };

    // ------------------------------------

    const navigate = useNavigate();
    useEffect(() => {
        if (!isAuthenticated || !user) {
            navigate("/");
        }
    }, [isAuthenticated, user]);

    const [selected, setSelected] = useState([]);
    const [originalItems, setOriginalItems] = useState([]);
    const [selectedCurrentItems, setSelectedCurrentItems] = useState([]);
    const [selectedDownloads, setSelectedDownloads] = useState([]);
    const [currentMapKey, setCurrentMapKey] = useState("map-0");

    const drawOriginalPolygon = (originalItems) => {
        const newOriginalItems = originalItems.map((originalItem) => {
            const originalItemActual = originalItem.geometry.coordinates
            const reversedMultiPolygon = originalItemActual[0].map(polygon => {
                return [polygon[1], polygon[0]];
            });
            const actualPolygon = turf.polygon([reversedMultiPolygon]);
            const actualPolygonCenter = turf.center(actualPolygon);
            return {
                id: null,
                center: actualPolygonCenter.geometry.coordinates,
                polygon: actualPolygon.geometry.coordinates,
                feature: actualPolygon.geometry,
                isOriginalItem: true
            };
        });
        setOriginalItems(newOriginalItems);
        const currentMapIndex = currentMapKey.split("-")[1];
        setCurrentMapKey("map-" + (currentMapIndex + 1).toString());
    };

    const handleDownloadSelection = (index, item, isSelected) => {
        let newSelectedCurrentItems = [];
        let newItemsForDownload = [...selectedDownloads];
        // aggiungo booleano di isSelected alla lista di oggetti selezionati per "deselect all"
        const updatedSelected = [...selected]
        updatedSelected[index] = isSelected
        setSelected(updatedSelected)

        if (isSelected) {
            // mantengo la lista attuale
            newSelectedCurrentItems = selectedCurrentItems;
            // aggiungo gli item alla lista dei selectedCurrentItems

            let itemObject = {};
            const itemActual = item.geometry.coordinates
            // const itemActual = orderDetails.process.item_list.features[0].geometry.coordinates
            const reversedMultiPolygon = itemActual[0].map(polygon => {
                return [polygon[1], polygon[0]];
            });
            const actualPolygon = turf.polygon([reversedMultiPolygon]);
            const actualPolygonCenter = turf.center(actualPolygon);
            itemObject = {
                id: item.frame_id,
                center: actualPolygonCenter.geometry.coordinates,
                polygon: actualPolygon.geometry.coordinates,
                feature: actualPolygon.geometry,
                isOriginalItem: false
            };
            newSelectedCurrentItems.push(itemObject);

            //Per Multidownload
            newItemsForDownload[index] = item
            // newItemsForDownload.push(item)
        } else {
            // devo togliere l'item dalla lista dei selectedCurrentItems

            const itemsToMantain = selectedCurrentItems.filter((selectedCurrentItem) => {
                return selectedCurrentItem.id !== item.frame_id;
            });
            const filterItemsForDownload = selectedDownloads.filter(item => item).filter((selectedDownl) => {
                return selectedDownl.frame_id !== item.frame_id;
            });
            // const newItemsForDownload = [...selectedDownloads];
            // delete newItemsForDownload[index];


            newSelectedCurrentItems = itemsToMantain;
            newItemsForDownload = filterItemsForDownload;
        }
        setSelectedDownloads(newItemsForDownload)
        //per Multidownload
        // aggiorno la variabile locale
        setSelectedCurrentItems(newSelectedCurrentItems);
        const currentMapIndex = currentMapKey.split("-")[1];
        setCurrentMapKey("map-" + (currentMapIndex + 1).toString());
    };

    const handleDeselectAll = () => {
        setSelectedCurrentItems([]);
        setSelected([])
        setSelectedDownloads([])
        setSelectAllChecked(false)
    };

    const handleSelectAll = React.useCallback(() => {
        const features = orderDetails?.process?.arguments?.frames?.features.map((feature, index) => {
            return {...feature, item: orderDetails.process.item_list.features.find(elem => elem.id === feature.properties.id_L0)}
        }) || [];
        const updatedSelected = features.map(() => true);
        const selectedPolygons = itemsToPolygons(features);

        setSelected(updatedSelected)
        setSelectedDownloads(features)
        setSelectAllChecked(true)
        setSelectedCurrentItems(selectedPolygons);
    }, [orderDetails?.process?.arguments?.frames?.features]);


    // multidownload
    const handleMultipleDownloads = (list: null) => {
        // preparo gli item da scaricare
        const items = list && Array.isArray(list) ? list : selectedDownloads;
        // TODO: far scaricare solo attivi (togliere il blocco in 'isDownloadAllDisabled')
        // invio alla coda di download
        addItemsToQueue(items.filter(selectedItem => selectedItem).map((selectedItem) => {
            let filename = '';
            filename = orderDetails.hasOwnProperty('frames_file_names') &&
                       orderDetails.frames_file_names.hasOwnProperty(selectedItem.frame_id) &&
                       orderDetails.frames_file_names[selectedItem.frame_id] ?
                            orderDetails.frames_file_names[selectedItem.frame_id] : '';
            if (!filename) { // fallback
                filename = 'Job_' + orderDetails.job_id + '_frame_' + selectedItem.frame_id;
            }
            // nel caso di JOB questo è il nome dell'L0
            // const splittedFileUrl = selectedItem.item && selectedItem.item.assets && selectedItem.item.assets.image ? selectedItem.item.assets.image.href.split('/') : [];
            // if (splittedFileUrl.length) {
            //     filename = splittedFileUrl[splittedFileUrl.length-1];
            // }
            return {
                url: `${process.env.REACT_APP_MAPIT_API_URL}${process.env.REACT_APP_MAPIT_API_NP_DOWNLOAD}${orderId}/${selectedItem.frame_id}`,
                name: `Order ${orderId} # Frame ${selectedItem.frame_id}`,
                filename
            }
        }));
    };

    // map elements, center, panning and layers -------------------------------------------------------------
    const defaultCenterCoordinates = [42.098222, 12.304688];
    const [centerCoordinates, setCenterCoordinates] = useState(defaultCenterCoordinates);
    const [mapChildren, setMapChildren] = useState([]);
    const [currentBounds, setCurrentBounds] = useState(null);
    useEffect (() => {
        // items and centering
        if (originalItems && originalItems.length) { // essendo una pagina di dettaglio, aspetto questo...
            let currentMapCenterObject = null;
            if (selectedCurrentItems && selectedCurrentItems.length) {
                const featureList = {"type": "FeatureCollection", "features": []}
                selectedCurrentItems.forEach(item => {
                    const feature = turf.polygon(item.feature.coordinates);
                    featureList.features.push(feature);
                });
                currentMapCenterObject = turf.center(featureList);
            } else if (originalItems && originalItems.length) {
                const featureList = {"type": "FeatureCollection", "features": []}
                originalItems.forEach(item => {
                    const feature = turf.polygon(item.feature.coordinates);
                    featureList.features.push(feature);
                });
                currentMapCenterObject = turf.center(featureList);
            }
            // se ho trovato il centro...
            if (currentMapCenterObject) {
                console.log('Map position:', currentMapCenterObject.geometry.coordinates);
                setCenterCoordinates(currentMapCenterObject.geometry.coordinates);
            } else if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    console.log('User position:', latitude, longitude);
                    setCenterCoordinates([latitude, longitude]);
                });
            } else {
                console.log('Geolocation is not supported by this browser.');
            }
        }

        // layers to draw
        const layers = L.layerGroup();
        let updatedMapChildren = originalItems.map((item, index) => {
            const layer = L.polygon(item.polygon, {color: '#e41b13'});
            layers.addLayer(layer);
            return (
                <Polygon key={`polygon-${index}`} color="#e41b13" positions={item.polygon}/>
            )
        });
        const selectedMapChildren = selectedCurrentItems.map((item, index) => {
            const layer = L.polygon(item.polygon, {color: '#FFFFFF'});
            layers.addLayer(layer);
            return (
                <Polygon key={index} color="#FFFFFF" positions={item.polygon}/>
            )
        });
        updatedMapChildren = updatedMapChildren.concat(selectedMapChildren);
        setMapChildren(updatedMapChildren);

        // bounds and panning
        if (layers && layers._layers) {
            let allCoordinates = [];
            Object.keys(layers._layers).forEach((layerKey) => {
                if (layers._layers[layerKey]._latlng) {

                } else if (layers._layers[layerKey]._latlngs) {
                    layers._layers[layerKey]._latlngs.forEach((coords) => {
                        const allLayerCoords = coords.map((layerCoords) => ([layerCoords.lng, layerCoords.lat]));
                        allCoordinates.push(allLayerCoords);
                    });
                }
            })
            setCurrentBounds(panMapToBBoxBoundsCoordinates(mapRef, allCoordinates));
        }
    }, [originalItems, selectedCurrentItems]);

    const handleStatuCheck = () => {
        setCheckForStatusChange((prevCounter) => prevCounter + 1)
    }

    const isDownloadAllDisabled = useMemo(() => 
        !selectedDownloads.length || !selectedDownloads.every((item, index) => isDownloadAvailable(item.frame_id)), 
    [selectedDownloads, isDownloadAvailable])

    const renderFrameStatus = (frame_id) => {
        if (downloadStatus(frame_id) === "running") {
            return <><HourglassSplit alt={downloadStatus(frame_id)} /> {downloadStatus(frame_id)}</>
        } else if (downloadStatus(frame_id) === "expired") {
            return <><HourglassBottom alt={downloadStatus(frame_id)} /> {downloadStatus(frame_id)}</>
        } else if (downloadStatus(frame_id) === "finished") {
            return <><Check alt={downloadStatus(frame_id)} /> {downloadStatus(frame_id)}</>
        } else {
            return <><Exclamation alt={downloadStatus(frame_id)} /> {downloadStatus(frame_id)}</>
        }
    }

    return (
        <div className="m-5" style={{paddingTop: '60px'}}>
            <Row>
                <Col>
                    <Link to="/profile">
                        <Button className='button1 element1'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="16" fill="currentColor"
                                 viewBox="0 0 16 16">
                                <path fillRule="evenodd"
                                      d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5z"/>
                            </svg>
                        </Button>
                    </Link>
                </Col>
            </Row>


            <Row className="mt-3">
                <MapContainer
                    style={{maxHeight: "350px", marginBottom: "30px"}}
                    bounds={currentBounds}
                    maxBounds={Leaflet.latLngBounds(
                        Leaflet.latLng(-90, -180),
                        Leaflet.latLng(90, 180)
                    )}
                    key={currentMapKey}
                    center={centerCoordinates}
                    zoom={5}
                    maxZoom={17}
                    minZoom={3}
                    height={100}
                    scrollWheelZoom={true}
                    trackResize
                    children={mapChildren}
                    ref={mapRef}
                >
                    {/*<TileLayer*/}
                    {/*    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'*/}
                    {/*    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
                    {/*/>*/}
                    <FeatureGroup>
                        <LayersControl position="topright">
                            <BaseLayer checked name="Streets map">
                                <TileLayer
                                    className="map-layer-view"
                                    attribution="Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012"
                                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                                />
                            </BaseLayer>
                            <BaseLayer name="Dark map">
                                <TileLayer
                                    className="map-layer-view"
                                    url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
                                    attribution={
                                        "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors &copy; <a href=\"https://carto.com/attributions\">CARTO</a>"
                                    }
                                />
                            </BaseLayer>
                            <BaseLayer name="Topographic map">
                                <TileLayer
                                    className="map-layer-view"
                                    attribution="Tiles &copy; Esri &mdash; Esri, DeLorme, ... , Esri China (Hong Kong), and the GIS User Community"
                                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
                                />
                            </BaseLayer>
                            <BaseLayer name="Satellite map">
                                <TileLayer
                                    className="map-layer-view"
                                    attribution="Tiles &copy; Esri &mdash; Esri, DeLorme, ... , Esri China (Hong Kong), and the GIS User Community"
                                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                />
                            </BaseLayer>
                            <BaseLayer name="Satellite map with labels">
                                <LayerGroup>
                                    <TileLayer
                                        className="map-layer-view"
                                        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                        attribution={
                                            "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors &copy; <a href=\"https://carto.com/attributions\">CARTO</a>"
                                        }
                                    />
                                    <TileLayer
                                        className="map-layer-view"
                                        attribution="Tiles &copy; Esri &mdash; Esri, DeLorme, ... , Esri China (Hong Kong), and the GIS User Community"
                                        url="https://{s}.basemaps.cartocdn.com/dark_only_labels/{z}/{x}/{y}.png"
                                    />
                                </LayerGroup>
                            </BaseLayer>
                        </LayersControl>
                    </FeatureGroup>

                    {
                        mapChildren
                    }
                    <FlyToMap center={centerCoordinates} zoom={8}/>

                </MapContainer>
            </Row>
            <div className="mt-4">
                <h4 className="font-weight-bold">Order Information</h4>
                <table className="table table-borderless table-transparent mt-2 custom-table">
                    {order && <tbody className='tb1'>
                        <tr>
                            <td className="tr1">Order Code:</td>
                            <td>{order.code}</td>
                        </tr>
                        <tr>
                            <td className="tr1">Order Date:</td>
                            <td>{order ? order.date : " - "}</td>
                        </tr>
                        <tr>
                            <td className="tr1">Description:</td>
                            <td>{order ? order.description : " - "}</td>
                        </tr>
                        <tr>
                            <td className="tr1">Multi-Look:</td>
                            <td>{orderDetails ? orderDetails.process.arguments.multilook : " - "}</td>
                        </tr>
                        <tr>
                            <td className="tr1">Processing Level:</td>
                            <td>{orderDetails ? orderDetails.process.arguments.processing_level : " - "}</td>
                        </tr>
                        <tr>
                            <td className="tr1">Product Format:</td>
                            <td>{orderDetails ? orderDetails.process.arguments.product_format : " - "}</td>
                        </tr>
                        </tbody>}
                </table>
            </div>
            <div>

            </div>
            <div>
                <Table striped bordered hover responsive className='a1Tab'>
                    <thead>{renderColumnNames("downloads", ['Frame ID',  'ID L0', 'Sensor Time Start', 'Sensor Time Stop', 'Status', 'Download'])}</thead>
                    <tbody>
                    {order && order.features.map((feature, index) => {
                            return (
                                <tr key={index}>
                                    <td align="center">
                                        <input
                                            type="checkbox"
                                            name="selectedItem"
                                            // value={download.stac_item.id}
                                            checked={selected[index]}
                                            onChange={(e) => handleDownloadSelection(index, feature, e.target.checked)}
                                        />
                                    </td>
                                    <td>{feature.frame_id}</td>
                                    <td>{feature.properties ? feature.properties.id_L0 : " - "}</td>
                                    <td>{feature.properties ? formatDate(feature.properties.sensor_time_start) : " - "}</td>
                                    <td>{feature.properties ? formatDate(feature.properties.sensor_time_stop) : " -  "}</td>
                                    <td>{feature.properties ? renderFrameStatus(feature.frame_id) : " - "}
                                        <Button className='button1 m-3' onClick={handleStatuCheck}>
                                            <ArrowClockwise />
                                        </Button>
                                    </td>
                                    <td className='text-center'>
                                        <Button className='button1'
                                                onClick={() => {
                                                    handleMultipleDownloads([feature])
                                                }}
                                                disabled={!isDownloadAvailable(feature.frame_id)}
                                        > 
                                            <ArrowDown />
                                        </Button>
                                    </td>
                                </tr>
                            )
                            // }
                        }
                    )}
                    </tbody>
                </Table>
                <Row className='mb-3'>
                    <Row>

                        <Col>
                            <Button disabled={isDownloadAllDisabled}
                                    className='button1 d-flex justify-content-left mb-3'
                                    onClick={handleMultipleDownloads}>Download Selected</Button>
                        </Col>

                        <Col>

                            {/* {renderPageSwitch()} */}
                        </Col>

                    </Row>
                </Row>
            </div>
            <MapitalyModal {...modal}></MapitalyModal>
        </div>

    );
};

const mapStateToProps = state => ({
    user: state.auth.user,
    isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, {
    addItemsToQueue
})(ProfileDetails);

export const panMapToBBoxBoundsCoordinates = (mapRef, allCoordinates: any[]) => {
    const bbox = extractBBoxByCoordinates(allCoordinates);
    let currentBounds = null;
    if (!!mapRef && !!bbox) {
        const map = mapRef.current;
        if (map) {
            currentBounds = [
                [bbox.minLat, bbox.minLong],
                [bbox.minLat, bbox.maxLong],
                [bbox.maxLat, bbox.maxLong],
                [bbox.maxLat, bbox.minLong],
            ]
            map.fitBounds(currentBounds);
        }
    }
    return currentBounds;
};
